<script lang="ts">
import Vue, { VNode, CreateElement } from 'vue';
import PopupWithButton from '@/components/PopupWithButton.vue';

export default Vue.extend({
    name: 'RichText',
    props: {
        html: {
            type: String,
            default: ''
        },
        /** 为真时，内联 apply-button 节点仅作展示，不触发业务 click 且不向上冒泡（与卡片主按钮禁用态一致） */
        disabled: {
            type: Boolean,
            default: false
        },
        /** 购物车/结账页：与 applyPromotionApplied 配合切换 checkout.applied 文案 */
        checkoutApplyPromotionContext: {
            type: Boolean,
            default: false
        },
        /** 结账页促销 usage 已同步到数量时为 true，展示 checkout.applied */
        applyPromotionApplied: {
            type: Boolean,
            default: false
        }
    },
    components: {
        PopupWithButton
    },
    render( h: CreateElement ): VNode {

        if ( !this.html ) {

            return h( 'div' );

        }

        // 使用 DOMParser 解析 HTML 字符串
        const parser = new DOMParser();
        const doc = parser.parseFromString( this.html, 'text/html' );

        // 递归将 DOM 节点转换为 VNode
        const convertNode = ( node: ChildNode ): VNode | string | Array<VNode | string> => {

            if ( node.nodeType === Node.TEXT_NODE ) {

                return node.textContent ?? '';

            } else if ( node.nodeType === Node.ELEMENT_NODE ) {

                const element = node as HTMLElement;
                const children = Array.from( element.childNodes ).map( convertNode );

                // 将 <popup> 标签渲染为 PopupWithButton 组件
                if ( element.tagName.toLowerCase() === 'popup' ) {

                    return h( PopupWithButton, {
                        props: {
                            content: element.getAttribute( 'content' ),
                            button: element.textContent
                        }
                    });

                } else if ( element.tagName.toLowerCase() === 'apply-button' ) {

                    const isAppliedCheckout = this.checkoutApplyPromotionContext && this.applyPromotionApplied;
                    const label = ( isAppliedCheckout ? this.$t( 'checkout.applied' ) : this.$t( 'cart.apply_now' )) as string;

                    if ( this.disabled || isAppliedCheckout ) {

                        return h( 'span', {
                            class: 'rich-text__btn rich-text__btn--disabled'
                        }, [ label ] );

                    }
                    return h( 'button', {
                        class: 'rich-text__btn',
                        attrs: { type: 'button' },
                        on: {
                            click: ( e: MouseEvent ) => {

                                this.$emit( 'click', e, 'apply-promotion' );

                            }
                        }
                    }, [ label ] );

                } else {

                    return h( element.tagName.toLowerCase(), {}, children );

                }

            }

            return '';

        };

        // 转换 body 的所有子节点
        const children = Array.from( doc.body.childNodes ).map( convertNode );

        return h( 'div', { class: 'rich-text' }, children );

    }
});
</script>

<style lang="less" scoped>
.rich-text{
    /deep/ .rich-text__btn{
        margin: 0;
        padding: 0;
        border: none;
        background: none;
        font: inherit;
        line-height: inherit;
        text-align: inherit;
        color: @brand_light;
        text-decoration: underline;
        cursor: pointer;
        &:hover{
            color: @brand_light_hover;
        }
        &:active{
            color: @brand_light_click;
        }
    }
    /deep/ .rich-text__btn--disabled{
        cursor: default;
        color: @font_tertiary;
        text-decoration: none;
        pointer-events: none;
        &:hover,
        &:active{
            color: @font_tertiary;
        }
    }
}
</style>
